import React, { useState, useEffect } from "react";

import { TextField, Button,
  Dialog, DialogActions, DialogContent,
  DialogTitle, Slide, IconButton,
} from "@mui/material";

import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
} from "@mui/material";
import {DatePicker} from "@heroui/react";

import { crearLicencias, editarLicencias } from "../../service/apiService";
import { useForm, Controller } from "react-hook-form";
import { useAppDispatch, useAppSelector } from '../../provider/app/hooks';
import { I18nProvider } from "@react-aria/i18n";
import {getLocalTimeZone, today} from "@internationalized/date";
import { addItem, updateItem } from '../../provider/Slice/GruposSlice';
import { InputStyle, RadioButton } from "../../SXStyle";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogLicense({ open, setOpen, registro = null , setSnackbar }) {
  
  const dispatch = useAppDispatch();

  //react-hook-form
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      entitlement: "",
      type: "1",
      model: "1",
      state: "1",
      seats_total: "",
      seats_reserved: "",
      valid_from: "",
      valid_until: "",
    }
  });

  const handleDialogClose = () => {
    setOpen(false);
  };

  //si es un edit - llena los valores del registro
  //si es un nuevo registro - valores por default
  useEffect(() => {
    if(registro !== null && open)
    {
      reset({
        id: registro.id,
        entitlement: registro.name,
        type: registro.type,
        model: registro.description,
        state: registro.status,
        seats_total: registro.seats_total,
        seats_reserved: registro.seats_reserved,
        seats_reserved: registro.seats_reserved,
        valid_from: registro.valid_from,
        valid_until: registro.valid_from
      })
    }
    else if (registro === null && open) {
      reset({
        id: null,
        name: "",
        entitlement: "",
        type: "1",
        model: "1",
        state: "1",
        seats_total: "",
        seats_reserved: "",
        valid_from: "",
        valid_until: "",
      });
    }

  },[registro, open, reset])

  //guarda el registro
  const onSubmit = async (data) => {
    
    try {
      
      let result;

      let request = {
        ...data,
        valid_from : data.valid_from.year + "-" + String(data.valid_from.month).padStart(2, "0") + "-" + String(data.valid_from.day).padStart(2, "0"),
        valid_until : data.valid_until.year + "-" + String(data.valid_until.month).padStart(2, "0") + "-" + String(data.valid_until.day).padStart(2, "0"),
      }

      //edita el registro
      if(registro && registro.id)
      {
        result = await editarLicencias(request , registro.id);
        dispatch(updateItem(result.data));
      }
      else if(!registro) //nuevo registro
      {
        result = await crearLicencias(request);
        dispatch(addItem(result.data));
      }

      //si las credenciales son invalidas
      if (result)
        setSnackbar({ message: result.message, open: true });
    } 
    catch (error) {
      console.log({ error });
      setSnackbar({ message: "Ocurrió un error inesperado, intente de nuevo", open: true });
    }

    //limpia los datos despues de mandar una solicitud
    reset();

    handleDialogClose();
  };


  return (
    <React.Fragment>
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
          },
        }}
      >
        <DialogTitle>
          <p className="text-white font-bold"> Licencia </p>
        </DialogTitle>
        
        <DialogContent>
          <form
            id="mi-formulario"
            className="space-y-4 md:space-y-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Controller
              name="name"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nombre"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.name}
                  helperText={errors.name ? "Campo faltante  o inválido" : ""}
                />
              )}
            />
            
            <Controller
              name="entitlement"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Permiso"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.entitlement}
                  helperText={errors.entitlement ? "Campo faltante  o inválido" : ""}
                />
              )}
            />

            {/*  Checkbox */}
            <div className="flex"> 
              <div> 
              <FormControl component="fieldset" error={!!errors.model}>
                <p className="text-white font-bold"> Modelo </p>
                <Controller
                  name="model"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <RadioGroup {...field}>
                      <FormControlLabel
                        value="1"
                        control={<Radio sx={RadioButton} />}
                        label="Floating"
                        sx={{ color: "#fffcfc" }}
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio sx={RadioButton} />}
                        label="Fixes"
                        sx={{ color: "#fffcfc" }}
                      />
                    </RadioGroup>
                  )}
                />
                {errors.model && (
                  <span style={{ color: "red" }}>Debes elegir una opción</span>
                )}
              </FormControl>
              </div>

              <div className="ml-4">
                <FormControl component="fieldset" error={!!errors.state} >
                  <p className="text-white font-bold"> Estado </p>
                  <Controller
                    name="state"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <RadioGroup {...field}>
                        <FormControlLabel
                          value="1"
                          control={<Radio sx={RadioButton} />}
                          label="Valido"
                          sx={{ color: "#fffcfc" }}
                        />
                        <FormControlLabel
                          value="2"
                          control={<Radio sx={RadioButton} />}
                          label="Invalido"
                          sx={{ color: "#fffcfc" }}
                        />
                        <FormControlLabel
                          value="3"
                          control={<Radio sx={RadioButton} />}
                          label="Expirado"
                          sx={{ color: "#fffcfc" }}
                        />
                      </RadioGroup>
                    )}
                  />
                  {errors.state && (
                    <span style={{ color: "red" }}>Debes elegir una opción</span>
                  )}
                </FormControl>
              </div>

              <div className="ml-4">
                <FormControl component="fieldset" error={!!errors.type} >
                  <p className="text-white font-bold"> Tipo </p>
                  <Controller
                    name="type"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <RadioGroup {...field}>
                        <FormControlLabel
                          value="1"
                          control={<Radio sx={RadioButton} />}
                          label="Seat"
                          sx={{ color: "#fffcfc" }}
                        />
                        <FormControlLabel
                          value="2"
                          control={<Radio sx={RadioButton} />}
                          label="concurrent"
                          sx={{ color: "#fffcfc" }}
                        />  
                      </RadioGroup>
                    )}
                  />
                  {errors.type && (
                    <span style={{ color: "red" }}>Debes elegir una opción</span>
                  )}
                </FormControl>
              </div>
            </div>

            {/*  Asientos */}
            <div className="flex "> 
              <div className="w-[45%]">
                <Controller
                  name="seats_total"
                  control={control}
                  rules={{
                    required: "Campo faltante o inválido",
                    validate: value => !isNaN(value) || "Debe ser un número"
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Asientos Totales"
                      type="number" // Define el input como numérico
                      className="rounded-lg block w-full  bg-inputs border"
                      sx={{ ...InputStyle, marginTop: "10px" }}
                      error={!!errors.seats_total}
                      helperText={errors.seats_total ? errors.seats_total.message : ""}
                      // Forzar que el valor sea un número en el onChange
                      onChange={e => field.onChange(e.target.value === '' ? '' : Number(e.target.value))}
                    />
                  )}
                />
              </div>

              <div className="w-[45%] ml-5">
                <Controller
                  name="seats_reserved"
                  control={control}
                  rules={{
                    required: "Campo faltante o inválido",
                    validate: value => !isNaN(value) || "Debe ser un número"
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Asientos Reservados"
                      type="number" // Define el input como numérico
                      className="rounded-lg block w-full bg-inputs border"
                      sx={{ ...InputStyle, marginTop: "10px" }}
                      error={!!errors.seats_reserved}
                      helperText={errors.seats_reserved ? errors.seats_reserved.message : ""}
                      // Forzar que el valor sea un número en el onChange
                      onChange={e => field.onChange(e.target.value === '' ? '' : Number(e.target.value))}
                    />
                  )}
                />
              </div>
            </div>

            <div className="flex"> 
              <div className="w-[210px]"> 
                <p className="text-white font-bold"> Válido desde </p>
                <I18nProvider locale="es-ES">
                  <Controller
                    name="valid_from"
                    control={control}
                    rules={{ required: "Campo obligatorio" }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        label="Válido desde"
                        variant="flat"
                        classNames={{
                          base: "custom-base-date-license",
                          input: "custom-input-date-license",
                          inputWrapper: "custom-input-wrapper-date",
                        }}
                        error={!!errors.valid_from}
                        helperText={errors.valid_from ? errors.valid_from.message : ""}
                        onChange={field.onChange}
                        value={field.value || null}
                        minValue={today(getLocalTimeZone())}
                      />
                    )}
                  />
                </I18nProvider>
              </div>

              <div className="w-[210px] ml-4">
                <p className="text-white font-bold"> Válido hasta </p>
                <I18nProvider locale="es-ES">
                  <Controller
                    name="valid_until"
                    control={control}
                    rules={{ required: "Campo obligatorio" }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        label="Válido hasta"
                        variant="flat"
                        classNames={{
                          base: "custom-base-date-license",
                          input: "custom-input-date-license",
                          inputWrapper: "custom-input-wrapper-date",
                        }}
                        error={!!errors.valid_until}
                        helperText={errors.valid_until ? errors.valid_until.message : ""}
                        onChange={field.onChange}
                        value={field.value || null}
                        minValue={today(getLocalTimeZone())}
                      />
                    )}
                  />
                </I18nProvider>
              </div>
            </div>





          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cancelar </p>
          </Button>
          <Button type="submit" form="mi-formulario">
            <p className="text-amarillo"> Aceptar </p>
          </Button>
        </DialogActions>
      
      </Dialog>
    </React.Fragment>
  );
}

export default DialogLicense;
